<template>
  <div>
    <div class="mb-0.5 pl-1 text-xs">
      {{ name }}
    </div>
    <button
      v-for="(tab, tabIdx) in items"
      :key="`${tabIdx}-tab`"
      class="h-8 w-28 border border-cdp-grey-400 px-4 py-1 text-sm duration-300"
      :class="{
        'hover:bg-cdp-main-primary hover:text-cdp-white': !props.disabled,
        'bg-cdp-main-primary text-cdp-white': tab.value === modelValue && !props.disabled,
        'rounded-bl-[4px] rounded-tl-[4px]': tabIdx === 0,
        'rounded-br-[4px] rounded-tr-[4px]': tabIdx === items.length - 1,
        'bg-cdp-grey-200': tab.value !== modelValue && props.disabled,
        'bg-cdp-grey-500 text-gray-200': tab.value === modelValue && props.disabled
      }"
      @click="set(tab.value)"
    >
      {{ tab.text }}
    </button>
  </div>
</template>

<script>
export default {
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   */
  name: 'Tabs',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    items: {
      type: Array,
      default: () => [
        {
          text: String,
          value: Number
        }
      ]
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    function set(val) {
      if (props.disabled) return false;
      emit('update:modelValue', val);
      emit('change', val);
    }

    return {
      set,
      props
    };
  }
};
</script>